import * as Yup from 'yup';

export const PasswordSchema = Yup.string()
  .required('You must enter a password')
  .min(8)
  .max(100)
  .test(
    'contain-number',
    'Password must contain a number',
    (value: string | undefined) => value != null && /\d/.test(value)
  )
  .test(
    'contain-capital',
    'Password must contain a capital letter',
    (value: string | undefined) => value != null && /[A-Z]/.test(value)
  );

export const ConfirmPasswordSchema = (passwordField: string) =>
  Yup.string()
    .required('Please confirm your password')
    .when(passwordField, {
      is: (val: string) => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf([Yup.ref(passwordField)], 'Passwords must match'),
    });
